import { render, staticRenderFns } from "./SincronizacaoPropostas.vue?vue&type=template&id=038e8e20&"
import script from "./SincronizacaoPropostas.vue?vue&type=script&lang=js&"
export * from "./SincronizacaoPropostas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports